import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef } from "react";
import { ButtonWithTooltipProps } from ".";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";


const TooltipButton = forwardRef<HTMLButtonElement, ButtonWithTooltipProps>(({ 
    tooltipContent, 
    asChild = false, 
    variant, 
    size, 
    className, 
    tooltipProps, 
    tooltipContentProps, 
    tooltipTriggerProps, 
    ...props 
}, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
        <Tooltip {...tooltipProps}>
            <TooltipTrigger asChild {...tooltipTriggerProps}>
                <Comp
                    className={cn(buttonVariants({ variant, size, className }))}
                    ref={ref}
                    {...props}
                />
            </TooltipTrigger>
            <TooltipContent {...tooltipContentProps}>
                {tooltipContent}
            </TooltipContent>
        </Tooltip>
    )
})

TooltipButton.displayName = "TooltipButton"
export { TooltipButton }